import { render, staticRenderFns } from "./TotalCalls.vue?vue&type=template&id=4992d139&scoped=true"
import script from "./TotalCalls.vue?vue&type=script&lang=js"
export * from "./TotalCalls.vue?vue&type=script&lang=js"
import style0 from "./TotalCalls.vue?vue&type=style&index=0&id=4992d139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4992d139",
  null
  
)

export default component.exports